import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { SHIFT_META } from "@/lib/shifts";

export default function WeekAgenda() {
  const { t, lang } = useI18n();
  const [days, setDays] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/week", { params: { days: 7 } });
    setDays(data.days);
  }, []);

  useEffect(() => { load(); }, [load, lang]);

  const dayName = (iso) =>
    new Date(iso + "T00:00:00").toLocaleDateString(lang, { weekday: "short" });
  const dayNum = (iso) => Number(iso.slice(8, 10));

  return (
    <div data-testid="week-agenda">
      <h3 className="font-display font-bold text-lg mb-3">{t("thisWeek")}</h3>
      <div className="flex gap-2.5 overflow-x-auto no-scrollbar pb-1 -mx-1 px-1 snap-x">
        {days.map((d) => {
          const meta = SHIFT_META[d.shift] || SHIFT_META.off;
          const Icon = meta.icon;
          return (
            <div
              key={d.date}
              data-testid={`week-day-${d.date}`}
              className="snap-start shrink-0 w-24 rounded-xl border p-3 flex flex-col gap-2"
              style={{ borderColor: d.is_today ? meta.color : "rgba(255,255,255,0.1)", backgroundColor: `${meta.color}12` }}
            >
              <div className="flex items-center justify-between">
                <span className="text-xs uppercase tracking-wide text-muted-foreground capitalize">{dayName(d.date)}</span>
                <span className="text-sm font-bold">{dayNum(d.date)}</span>
              </div>
              <Icon className="h-5 w-5" style={{ color: meta.color }} />
              <span className="text-sm font-semibold" style={{ color: meta.color }}>{t(d.shift)}</span>
              {d.shift !== "off" && d.start && (
                <span className="text-[11px] text-muted-foreground">{d.start}–{d.end}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
